import React, { useState } from 'react';
import { Menu, MenuItem, Divider, Box, Typography, Avatar } from '@mui/material';
import { AccountCircle, ExitToApp, Help, Brightness4, Brightness7 } from '@mui/icons-material';
import { alpha, useTheme } from '@mui/material/styles';
import { useAuth } from '../../pages/authentication/AuthContext';
import { useNavigate } from 'react-router-dom'; // 👈 ADD THIS

// Profile Menu
const ProfileMenu = ({ profileMenuAnchor, handleProfileMenuClose, logout }) => {
  const theme = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate(); // 👈 Initialize navigate

  // Helper to get route path based on role
  const getRoutePath = (path) => {
    if (!user?.role) return '/';
    return `/${user.role}/${path}`;
  };

  const handleNavigation = (path) => {
    navigate(getRoutePath(path)); // Navigate to /{user.role}/path
    handleProfileMenuClose();     // Close menu after navigation
  };

  return (
    <Menu
      anchorEl={profileMenuAnchor}
      open={Boolean(profileMenuAnchor)}
      onClose={handleProfileMenuClose}
      PaperProps={{
        sx: {
          borderRadius: theme.spacing(2),
          minWidth: 220,
          bgcolor: alpha(theme.palette.background.paper, 0.95),
          backdropFilter: 'blur(20px)',
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.12)}`
        }
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <Box sx={{ p: theme.spacing(2) }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: theme.spacing(2) }}>
          <Avatar
            src={user.profile_pic ? `${process.env.REACT_APP_API_URL}${user.profile_pic}` : undefined}
            sx={{
              width: 40,
              height: 40,
              mr: theme.spacing(1.5),
              bgcolor: theme.palette.primary.main
            }}
          >
            {`${user.first_name?.charAt(0).toUpperCase() ?? ''}${user.last_name?.charAt(0).toUpperCase() ?? ''}`}
          </Avatar>
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              {`${user.first_name} ${user.last_name}`}
            </Typography>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
              {user.phone}
            </Typography>
          </Box>
        </Box>
        <Divider sx={{ my: theme.spacing(1) }} />
      </Box>

      {[
        { icon: AccountCircle, label: 'Profile Settings', path: 'profile' },
        { icon: Help, label: 'Help & Support', path: 'support' },
      ].map((item, index) => (
        <MenuItem
          key={index}
          onClick={() => handleNavigation(item.path)} // 👈 Navigates to /{user.role}/path
          sx={{
            py: theme.spacing(1.5),
            px: theme.spacing(2),
            '&:hover': {
              bgcolor: alpha(theme.palette.primary.main, 0.08)
            }
          }}
        >
          <item.icon sx={{ mr: theme.spacing(2), fontSize: 20 }} />
          {item.label}
        </MenuItem>
      ))}

      <Divider />

      <MenuItem
        onClick={logout}
        sx={{
          py: theme.spacing(1.5),
          px: theme.spacing(2),
          color: theme.palette.error.main,
          '&:hover': {
            bgcolor: alpha(theme.palette.error.main, 0.08)
          }
        }}
      >
        <ExitToApp sx={{ mr: theme.spacing(2), fontSize: 20 }} />
        Sign Out
      </MenuItem>
    </Menu>
  );
};

export default ProfileMenu;